<div class="line">
    <span>{{ 'PAY_AT_TABLE.TOTAL_PEOPLE' | translate }}</span>
    <div class="stepper">
        <button [disabled]="isDecTotalPeopleDisabled" (click)="decTotalPeople.emit()">
            <mat-icon>remove</mat-icon>
        </button>
        <span>{{ totalPeople }}</span>
        <button [disabled]="isIncTotalPeopleDisabled" (click)="incTotalPeople.emit()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>

<div class="line">
    <span>{{ 'PAY_AT_TABLE.PAYING_FOR' | translate }}</span>
    <div class="stepper">
        <button [disabled]="isDecPayingForDisabled" (click)="decPayingFor.emit()">
            <mat-icon>remove</mat-icon>
        </button>
        <span>{{ payingFor }}</span>
        <button [disabled]="isIncPayingForDisabled" (click)="incPayingFor.emit()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>

<div class="order-total">
    <div class="line">
        <span>{{ 'PAY_AT_TABLE.CHEQUE' | translate }}</span>
        <span class="right">{{ billAmount | currencySpace }}</span>
    </div>

    <div class="line">
        <h5>{{ 'PAY_AT_TABLE.REMAINING' | translate }}</h5>
        <h5 class="right">{{ totalRemaining | currencySpace }}</h5>
    </div>
</div>
